@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.step {
  margin-top: @space-16;
}

.step-header {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.step-icon {
  width: 18xp;
  height: 18px;
}

.step-icon-pending {
  .step-icon;
}

.step-icon-done {
  .step-icon;
  color: var(--green-700);
}

.step-title {
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
}

.step-info {
  margin-top: @space-4;
  // width of icon + gap
  margin-left: calc(18px + @space-8);
  color: var(--grey-600);
}
